import HeadComponent from "@/components/HeadComponent";
import YoutubeVideoModal from "@/components/podcast/youtubeVideoModal";
import SocialLinks from "@/components/SocialLinks";
import { callBackendApi } from "@/utils/common";
import moment from "moment";
import Image from "next/image";
import { useRouter } from "next/router";
import { useState } from "react";
import { BsDot } from "react-icons/bs";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { Tooltip } from "react-bootstrap";
import Link from "next/link";
import SpotifyIcon from "@/images/spotify.png";
import GooglePodcastIcon from "@/images/google_podcast.png";
import YoutubeIcon from "@/images/youtube.png";
import ApplePodcastIcon from "@/images/apple_podcast.svg";
import AmazonMusicIcon from "@/images/amazon_music.png";



export default function (props) {
  const { podcast } = props;
  if (!podcast) {
    return (
      <div className="container py-5">
        <p>Podcast not found</p>
      </div>
    );
  }


  const {
    title,
    createdAt,
    description,
    coverPhoto,
    timeDuration,
    aboutGuests,
    guests,
    transcript,
    keyPoints,
    thumbnailImage,
    relevantLinks,
    embedYoutubeUrl,
  } = podcast;

  const router = useRouter();
  const currentUrl = "https://moderndatastack.xyz" + router.asPath;
  const [showModal, setShowModal] = useState(false);
  const openModal = () => setShowModal(true);
  const hideModal = () => setShowModal(false);
  const [linkCopiedSuccess, setLinkCopiedSuccess] = useState(false);
  const handleCopyLink = () => {
    navigator.clipboard.writeText(currentUrl);
    setLinkCopiedSuccess(true);
    setTimeout(() => {
      setLinkCopiedSuccess(false);
    }, 1000);
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {linkCopiedSuccess ? "Link copied" : "Copy link"}
    </Tooltip>
  );

  return (
    <>
      <HeadComponent
        title={title}
        description={description}
        CustomTwitterImage={!!thumbnailImage}
        CustomTwitterImageUrl={thumbnailImage}
        CustomImage={!!thumbnailImage}
        CustomImageUrl={thumbnailImage}
      />
      {/* Hero section */}
      <div className=" pt-4 pb-3 mds-bg-primary-muted">
        <div className="container d-none d-lg-block">
          <nav className="py-3">
            <ol className="breadcrumb mds-breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/podcast">
                  <a>Episodes</a>
                </Link>
              </li>
              <li className="breadcrumb-item active">{title}</li>
            </ol>
          </nav>
        </div>

         {/* Main section */}



        <div className="container">
          <div className="d-flex flex-column flex-lg-row justify-content-start align-items-start gap-3">
            <div className="d-none d-lg-block ">
              <Image src={coverPhoto} layout="fixed" width={280} height={280} />
            </div>
            <div className="">
              <div className="d-flex flex-row justify-content-between mb-3">
                <div className="d-flex justify-content-start align-items-center gap-1 mds-text-secondary">
                  <span className="mds-fw-sm mds-fs-sm">
                    {moment(createdAt).format("MMM DD, YYYY")}
                  </span>
                  <span>
                    <BsDot />
                  </span>
                  <span className="mds-fw-sm mds-fs-sm">
                    {timeDuration + " min"}
                  </span>
                </div>
                <div className="d-flex flex-row gap-3 align-items-center">
                  <span className="mds-text-secondary mds-fs-sm mds-fw-sm">
                    Share via:
                  </span>
                  <SocialLinks
                    linkedInProfileUrl={`https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}`}
                    twitterProfileUrl={`https://twitter.com/share?text=${title}&url=${currentUrl}`}
                    // websiteUrl={"sfd"}
                  />
                  <div>
                    <OverlayTrigger
                      trigger="hover"
                      placement="bottom"
                      rootClose
                      overlay={renderTooltip}
                    >
                      <img
                        onClick={handleCopyLink}
                        className="mds-cur-pointer"
                        width="25"
                        height="25"
                        src="/Illustrations/link.svg"
                        alt=""
                      />
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
              <h1 className="mds-text-dark m-0 mb-2 mds-fw-lg mds-fs-lg">
                {title}
              </h1>
              <div className=" d-lg-none mb-3">
              <Image src={coverPhoto} layout="responsive" width={264} height={264} />
            </div>
            <p style={{whiteSpace : "pre-wrap"}} className="mds-text-secondary mds-fw-sm mds-fs-4 m-0 mb-4">
                {description}
              </p>
              {embedYoutubeUrl &&
              <div>
                <button
                  onClick={openModal}
                  className="btn mds-btn-outline-primary mds-fw-md px-5 mds-border-radius"
                  >
                  Listen Now
                </button>
              </div>
              
              }
              <div className="py-3">
                  <div className="d-flex flex-row gap-3 align-items-center">
                    <span className="mds-text-muted">Available On: </span>
                    <a
                      href="https://open.spotify.com/show/1fcjVky1bJXqj3wgHYNTS0"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image
                        width={24}
                        height={24}
                        src={SpotifyIcon}
                        alt="spotify"
                        layout="fixed"
                      />
                    </a>
                    <a
                      href="https://podcasts.google.com/feed/aHR0cHM6Ly9mZWVkLnBvZGJlYW4uY29tL3RoZW1vZGVybmRhdGFzaG93L2ZlZWQueG1s"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Image
                        width={24}
                        height={24}
                        src={GooglePodcastIcon}
                        alt="google podcast"
                        layout="fixed"
                      />
                    </a>
                    <a href="https://www.youtube.com/channel/UC2HWYQrsVm0Dsyc0RvXMHtQ" target="_blank" rel="noreferrer">
                      <Image
                        width={34}
                        height={24}
                        src={YoutubeIcon}
                        alt="youtube"
                        layout="fixed"
                      />
                    </a>
                     <a href="https://music.amazon.com/podcasts/e1059239-7533-46e4-9396-4058d66ff68c/the-modern-data-show" target="_blank" rel="noreferrer">
                      <Image
                        width={24}
                        height={24}
                        src={AmazonMusicIcon}
                        alt="Amazon Music"
                        layout="fixed"
                      />
                    </a>
                    <a href="https://podcasts.apple.com/us/podcast/the-modern-data-show/id1643536568" target="_blank" rel="noreferrer">
                      <Image
                        width={24}
                        height={24}
                        src={ApplePodcastIcon}
                        alt="apple podcast"
                        layout="fixed"
                      />
                    </a>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container py-4">
        <div className="py-3">
          <h2 className="m-0 py-3 mds-fw-lg fs-4 mds-text-dark">
            About the guest
          </h2>
          <div className="row row-cols-lg-3 py-3">
            {guests
              .filter((guest) => guest.fullName !== "Aayush Jain")
              .map(
                ({
                  _id,
                  fullName,
                  title,
                  imageUrl,
                  linkedInLink,
                  twitterLink,
                }) => (
                  <div className="col" key={_id}>
                    <GuestCard
                      fullName={fullName}
                      title={title}
                      imageUrl={imageUrl}
                      linkedInLink={linkedInLink}
                      twitterLink={twitterLink}
                    />
                  </div>
                )
              )}
          </div>
          <p style={{whiteSpace : "pre-wrap"}} className="mds-fw-sm mds-fs-p mds-text-secondary">{aboutGuests}</p>
        </div>
        <div className="py-3">
          <h2 className="m-0 py-3 mds-fw-lg fs-4 mds-text-dark">
            In this episode
          </h2>
          <ul className="mds-fw-sm mds-fs-p mds-text-secondary">
            {keyPoints.map((keyPoint) => (
              <li>{keyPoint}</li>
            ))}
          </ul>
        </div>
        <div className="py-3">
          <h2 className="m-0 py-3 mds-fw-lg fs-4 mds-text-dark">Transcript</h2>
          <div className="mds-border-muted mds-border-radius ps-3 pe-1 py-5">
            <div
              style={{
                maxHeight: "400px",
                overflowY: "auto",
                overflowX: "hidden",
              }}
              className="d-flex flex-column gap-3 mds-scrollbar"
            >
              {transcript?.map(({ content, name, time }) => (
                <Transcript
                  key={`${time}:${name}`}
                  content={content}
                  name={name}
                  time={time}
                  guests={guests}
                />
              ))}
            </div>
          </div>
        </div>
        {relevantLinks?.length > 0 &&
        <div className="py-3">
          <h2 className="m-0 py-3 mds-fw-lg fs-4 mds-text-dark">
          Relevant Links
          </h2>
          <ul className="mds-fw-sm mds-fs-p mds-text-secondary">
            {relevantLinks.map(({ link, name }) => (
              <li>
                <a
                  className="mds-text-primary"
                  href={link}
                  target="_blank"
                  rel="noreferrer"
                >
                  {name}
                </a>
              </li>
            ))}
          </ul>
        </div>
        }
      </div>

      {/* Model */}
      {
        embedYoutubeUrl &&
        <YoutubeVideoModal
          show={showModal}
          onHide={hideModal}
          embedUrl={embedYoutubeUrl}
        />
      }
    </>
  );
}

const Transcript = ({ content, name, time, guests }) => {
  const guestCover = guests.find(({fullName}) => fullName === name)?.imageUrl;
  return (
    <div className="row">
      <div className="col-3 col-lg-2 text-end mds-fw-md">
        {guestCover ? (
          <Image
            layout="fixed"
            className="border mds-border-primary-light rounded-circle"
            src={guestCover}
            width={56}
            height={56}
          />
        ) : (
          name
        )}
      </div>
      <div className="col-9 col-lg-10 border-start mds-border-primary ps-3">
        <div className="mds-text-primary mds-fw-sm mds-fs-sm">{time}</div>
        <div className="mds-fw-sm mds-fs-4 mds-text-secondary">{content}</div>
      </div>
    </div>
  );
};

const GuestCard = (props) => {
  const { fullName, title, imageUrl, linkedInLink, twitterLink } = props;
  return (
    <div className="d-flex flex-row gap-3 align-items-start justify-content-start">
      <div>
        <Image
          layout="fixed"
          className="border mds-border-primary-light rounded-circle"
          src={imageUrl}
          width={90}
          height={90}
        />
      </div>
      <div className="d-flex flex-column">
        <div className="mds-fs-4 mds-fw-sm mds-text-dark">{fullName}</div>
        <div className="mds-text-muted mds-fs-5 mds-fw-sm mb-2">{title}</div>
        <SocialLinks
          className="d-flex justify-content-start align-items-center gap-2"
          linkedInProfileUrl={linkedInLink}
          twitterProfileUrl={twitterLink}
        />
      </div>
    </div>
  );
};

export const getServerSideProps = async (context) => {
  const { slug } = context.query;
  let podcast = null;
  // get podcast details
  await callBackendApi({
    method: "get",
    url: `/podcasts/${slug}`,
    context: context,
  })
    .then(({ data }) => {
      podcast = data;
    })
    .catch((error) => null);

  return {
    props: {
      podcast,
    },
  };
};
